// 개발용 더미 데이터 생성 함수
export const createDummyUserData = () => {
  return {
    success: true,
    data: {
      content: [
        {
          userUid: "123e4567-e89b-12d3-a456-426614174000",
          name: "김관리",
          email: "admin1@example.com",
          phone: "010-1234-5678",
          roles: ["SUPER"],
          userAuth: {
            signInId: "admin1",
            enabled: true,
            accountNonLocked: true,
          },
        },
        {
          userUid: "123e4567-e89b-12d3-a456-426614174001",
          name: "이매니저",
          email: "admin2@example.com",
          phone: "010-2345-6789",
          roles: ["ADMIN"],
          userAuth: {
            signInId: "admin2",
            enabled: true,
            accountNonLocked: true,
          },
        },
      ],
      totalPages: 1,
      totalElements: 2,
      first: true,
      last: true,
      number: 0,
      size: 10,
    },
  };
};

// 더미 API 함수들 (개발용)
export const dummyGetUsersApi = async (params) => {
  // console.log('더미 사용자 목록 조회:', params);
  // 실제 API 호출 시뮬레이션을 위한 지연
  await new Promise((resolve) => setTimeout(resolve, 500));
  return createDummyUserData();
};

export const dummyGetUserDetailApi = async (signInId) => {
  // console.log('더미 사용자 상세 조회:', signInId);
  await new Promise((resolve) => setTimeout(resolve, 300));
  return {
    success: true,
    data: {
      userUid: "123e4567-e89b-12d3-a456-426614174000",
      name: "김관리",
      email: "admin1@example.com",
      phone: "010-1234-5678",
      roles: ["SUPER"],
      userAuth: {
        signInId: signInId,
        enabled: true,
        accountNonLocked: true,
      },
    },
  };
};

export const dummyCreateUserApi = async (userData) => {
  // console.log('더미 사용자 생성:', userData);
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return {
    success: true,
    data: {
      userUid: "new-user-uuid",
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      roles: ["ADMIN"],
    },
  };
};

export const dummyUpdateUserApi = async (signInId, userData) => {
  // console.log('더미 사용자 수정:', signInId, userData);
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return {
    success: true,
    data: {
      userUid: "updated-user-uuid",
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      roles: ["ADMIN"],
    },
  };
};

export const dummyGetUserPublicKeyApi = async (keyId) => {
  // console.log('더미 공개키 조회:', keyId);
  await new Promise((resolve) => setTimeout(resolve, 200));
  return {
    success: true,
    data: {
      publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA...", // 더미 공개키
    },
  };
};
